import React from "react";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../contants/Endpoints";
import { useParams } from "react-router-dom";
import Spinner from "../../components/Reuseable/Spinner";
const SalesLedgerDetailsComponent = loadable(
  () => import("../../components/SalesLedger/SalesLedgerDetails")
);
type Props = {};

const SalesLedgerDetails = (props: Props) => {
  const { id } = useParams();
  const { data: salesDetailsData, isPending: salesDetailsLoading } = useGetHook(
    {
      queryKey: [`order${id}`],
      url: `${APIS.ORDER}${id}/`,
      params: {},
    }
  );
  return (
    <>
      {salesDetailsLoading ? (
        <Spinner />
      ) : (
        <SalesLedgerDetailsComponent salesDetailsData={salesDetailsData} />
      )}
    </>
  );
};

export default SalesLedgerDetails;
